import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CommentOutlined } from '@mui/icons-material';
import { Avatar, Grid,  } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router';
import CommentDrawer from './CommentDrawer';
import { CreateReport, DeletePost, Likes, Reblog } from './card/PostActions';
import { UserContext } from '../../context/UserContext';
import { PostImages } from '../post_images.widget';
import { removeHTMLtags } from '../../util/util'

const ITEM_HEIGHT = 48;

export default function PostCard({content, token}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openCommentDrawer, setOpenCommentDrawer] = React.useState(false)

  const { userDetails } = React.useContext(UserContext)

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let author = content?.account
  let navigate = useNavigate()
  
  if(!content){
    return (
      <div>No Content</div>
    )
  }
  
  
  return (
    <Card sx={{ minWidth: '90%', margin: '24px auto', borderRadius: 3, boxShadow: '0 2px 12px 0 rgba(0,0,0,0.07)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px 0 24px' }}>
        <div onClick={() => navigate("/profile/" + author?.id)} style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
          <Avatar alt={author?.username} src={author?.avatar} sx={{ width: 48, height: 48, border: '2px solid #e0e7ef' }} />
          <div>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#222' }}>@{author?.username}</Typography>
            {/* Optionally add more author info here */}
          </div>
        </div>
        <div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            MenuListProps={{
              'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: '20ch',
              },
            }}
          >
            {author?.id === userDetails?.id ?
              <MenuItem>
                <DeletePost id={content?.id} token={token} />
              </MenuItem>
              :
              <MenuItem>
                <CreateReport account_id={author?.id} status_ids={[content?.id]} token={token} />
              </MenuItem>
            }
          </Menu>
        </div>
      </div>

      {content?.media_attachments?.length > 0 &&
        <div style={{ margin: '18px 0 0 0' }}>
          <PostImages imgs={content?.media_attachments} />
        </div>
      }
      {content?.content && content?.content.includes('youtu.be') ?
        <iframe
          src={removeHTMLtags(content?.content)}
          style={{ width: '100%', height: 220, borderRadius: 12, marginTop: 18 }}
          title='Media'
        />
        :
        <div style={{ margin: '18px 24px', fontSize: 17, color: '#222', lineHeight: 1.6, position: 'relative' }}>
          {/* Stylish link styles for post content */}
          <style>{`
            .post-content-link {
              color: #4f8cff;
              background: linear-gradient(90deg, #4f8cff22 0%, #6ee7b722 100%);
              border-radius: 6px;
              padding: 2px 6px;
              text-decoration: none;
              font-weight: 600;
              transition: background 0.2s, color 0.2s, box-shadow 0.2s;
              box-shadow: 0 1px 6px 0 rgba(79,140,255,0.08);
            }
            .post-content-link:hover {
              color: #fff;
              background: linear-gradient(90deg, #4f8cff 0%, #6ee7b7 100%);
              box-shadow: 0 2px 12px 0 rgba(79,140,255,0.18);
              text-decoration: underline;
            }
          `}</style>
          <span
            dangerouslySetInnerHTML={{
              __html: (content?.content || '').replace(/<a /g, '<a class="post-content-link" ')
            }}
          />
        </div>
      }

      <CardContent sx={{ padding: '12px 24px 18px 24px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
          <Likes favourited={content?.favourited} count={content?.favourites_count} id={content?.id} token={token} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Button
              style={{ minWidth: 36, borderRadius: 8, padding: 6 }}
              onClick={() => setOpenCommentDrawer(true)}
              size="small"
            >
              <CommentOutlined />
            </Button>
            <Reblog reblogged={content?.reblogged} count={content?.reblogs_count} id={content?.id} token={token} />
          </div>
        </div>
      </CardContent>
      <CommentDrawer count={content?.replies_count} token={token} id={content?.id} open={openCommentDrawer} setOpen={setOpenCommentDrawer} />
    </Card>
  );
}